import { Pipe, PipeTransform } from '@angular/core';
import { CommonDateTimeFormatter } from './common-date-time-formatter';

@Pipe({
    name: 'usDate',
    standalone: false
})

export class USDatePipe implements PipeTransform {

    constructor(private commonDateTimeFormatter: CommonDateTimeFormatter){}

    transform(value: any, offsetMillis?: number): any {
        //console.log(offsetMillis);
        return this.commonDateTimeFormatter.transform(value, 'MM/dd/yyyy', offsetMillis);
    }
}